export function exportToCsv(filename, rows, columns) {
  if (!Array.isArray(rows) || rows.length === 0) return;
  const headers = columns.map(c => c.header || c.field);
  const csvRows = [headers.join(',')];
  rows.forEach(row => {
    const vals = columns.map(c => {
      const v = row[c.field];
      const s = v == null ? '' : String(v);
      // Escape quotes and commas
      if (/[",\n]/.test(s)) {
        return '"' + s.replace(/"/g, '""') + '"';
      }
      return s;
    });
    csvRows.push(vals.join(','));
  });
  const csv = csvRows.join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
